<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
        </b-card>

        <b-card>
          <div class="scrollable-table" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Household Number</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(info, index) in iga_infos" :key="info.id">
                <td>{{ index + 1 }}</td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </div>

          <h5 v-if="!flag" class="text-center text-secondary">
            No Data Found
          </h5>
          <div class="float-right">
            <!-- <pagination :data="trainees" :limit="2" @pagination-change-page="getResults"></pagination> -->
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "Create Trainee",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, PageHeader },
  data() {
    return {
      title: "After Training IGA Info",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "After Training IGA Info",
          active: true
        }
      ],
      iga_infos : []
    };
  },

  mounted() {
    this.getCodes();
  },
  methods: {
    getResults(page = 1) {
      http.get('api/after-training-iga-info')
        .then(response => {
            this.flag = true;
            this.trainees = response.data.trainees;
    });
    },
  },
};
</script>
<style>
  .scrollable-table {
    overflow-x: auto;
    white-space: nowrap;
  }
</style>
